import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';

import styles from './PrimaryButton.module.scss';

const cx = classNames.bind(styles);

const PrimaryButton = ({
  text = '',
  type = 'normal',
  accent = false,
  center = false,
  disabled = false,
  className = '',
  children = null,
  ...rest
}) => {
  return (
    <button
      type="button"
      disabled={disabled}
      className={cx(['container', type, { accent, center, disabled }, className])}
      {...rest}>
      {children || text}
    </button>
  );
};

PrimaryButton.propTypes = {
  text: PropTypes.string,
  type: PropTypes.oneOf(['normal', 'wide']),
  accent: PropTypes.bool,
  center: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
};

export default React.memo(PrimaryButton);
